























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { gettableinfo, addtopic, gettopclist } from "@/api/declare";
import { gettopicinfo, updatetopic } from "@/api/tissuemanage";
import { writeHeapSnapshot } from "v8";

@Component({
  name: "tissuemanage",
  components: {},
})
export default class extends Vue {
  mounted() {
    this.getlist();
    this.baseurl = (window as any).baseurl;
    let params: any = window.sessionStorage.getItem("json")
    this.listquery.userid = JSON.parse(params).data.id
    this.listquery.role = JSON.parse(params).data.role
  }
  private name = "";
  private baseurl = "";
  private radio = "";
  private isdiabled = true;
  private isshowaddicon = true;
  private dialogVisible = false;
  private datalist = [];
  private diatotal: any = 0;
  private pageshowsize: any = 0;
  private listquery = {
    level: -1,
    limit: 8,
    name: "",
    num: "",
    page: 1,
    state: -1,
    topictype: -1,
    userid: "",
    role: 0,
  };
  private ruleForm = {};
  private rules = [];
  getlist() {
    gettopclist(this.listquery).then((res) => {
      if (res.code === 200) {
        this.datalist = res.data.itemBeanList[0];
        this.diatotal = res.data.total;
        let paramdata = (res.data.total - 8) % 9;
        let pagedata: any = (res.data.total - 8) / 9;
        if (this.diatotal > 8) {
          if (paramdata == 0) {
            this.pageshowsize = parseInt(pagedata) + 1;
          } else {
            this.pageshowsize = parseInt(pagedata) + 2;
          }
        } else {
          this.pageshowsize = 1;
        }
      }
    });
  }
  searchdata(val) {
    if (val == null) {
      this.listquery.name = "";
    } else {
      this.listquery.name = this.name;
    }
    this.listquery.page = 1;
    this.listquery.limit = 8;
    this.isshowaddicon = true;
    this.getlist();
  }
  clearinput() {
    this.listquery.name = "";
    this.getlist();
  }
  addlist() {
    this.dialogVisible = true;
    this.radio = "";
    this.isdiabled = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
  /**
   * 改变页码
   */
  handleCurrentChange(val) {
    this.listquery.page = val;
    if (val == 1) {
      this.listquery.limit = 8;
      this.isshowaddicon = true;
    } else {
      this.listquery.limit = 9;
      this.isshowaddicon = false;
    }
    console.log(this.listquery);
    this.getlist();
  }
  private handleSizeChange(val: number) {
    this.listquery.page = val;
  }
  changeradio(val) {
    if (val == 0) {
      this.isdiabled = false;
    } else {
      this.isdiabled = true;
    }
  }
  declare() {
    let param: any = window.sessionStorage.getItem("json");
    if (param == null) {
      this.$message.warning('个人信息失效，请重新登录')
      this.$router.push('/login')
    }
    else {
       let parm_ = {
      userId: JSON.parse(param).data.id,
    }
  addtopic(parm_).then((res) => {
        if (res.code === 200) {
          window.sessionStorage.setItem("topicid", JSON.stringify(res.data));
          // window.sessionStorage.removeItem("iseditys");
          // window.sessionStorage.removeItem("iswatch");
          window.sessionStorage.removeItem("iswatch");
          window.sessionStorage.removeItem("iseditys");
          window.sessionStorage.removeItem("fziseditys");
          window.sessionStorage.removeItem("topicinfo");
          const { href } = this.$router.resolve({ path: "/declare/declare" });
          window.open(href, "_blank");
          this.dialogVisible = false;
        }
      });
    }
  }
  /**
   * 查看课题项
   */
  watchitem(val, event) {
    let addparm = {
      topicId: val.id,
    };
    let topicinfo: any = JSON.stringify(val);
    let time = val.createtime.substring(0, 4);
    window.sessionStorage.setItem("time", time);
    // 编辑 已撤回 未提交 驳回预算 驳回得进来是编辑
    //andy 修改
    window.sessionStorage.setItem("topicinfo", topicinfo);
    if (val.state == 2 || val.state == 3 || val.state == 4 || val.state == 5 || val.state == 7 || val.state == 11 || val.state == 13 || val.state == 14) {
      window.sessionStorage.setItem("topicid", JSON.stringify(addparm));
      //window.sessionStorage.removeItem("topicinfo");
      //window.sessionStorage.setItem("topicinfo", topicinfo);
      window.sessionStorage.removeItem("fziseditys");
      debugger
      // andy 阶段状态下添加提交按钮
      if(val.state == 13){
        window.sessionStorage.setItem("iswatch", "true");
      }
      // andy 结题状态下添加提交按钮
      if(val.state == 14){
        window.sessionStorage.setItem("iswatch", "true");
      }   
      if (val.state == 4) {
        window.sessionStorage.setItem("iseditys", "true");
        window.sessionStorage.setItem("iswatch", "true");
      } else {
        // val.isrefuse == 1 表示预算驳回后重新上传的数据
        if (val.isrefuse == 1) {
          if (val.num !== '') {
            window.sessionStorage.setItem("fziseditys", "false")
          } else {
            if (val.state == 5) {
              window.sessionStorage.removeItem("iseditys")
              window.sessionStorage.removeItem("iswatch")
              window.sessionStorage.removeItem("fziseditys")
            } else {
              window.sessionStorage.setItem("iseditys", "true")
              window.sessionStorage.setItem("iswatch", "true")
              window.sessionStorage.removeItem("fziseditys")
            }
          }
        } else {
          if (val.state == 5 || val.state == 7 || val.state == 11) {
            //  驳回后
            window.sessionStorage.removeItem("iseditys")
            window.sessionStorage.removeItem("iswatch")
          } else if (val.state == 3) {
            window.sessionStorage.removeItem("iseditys")
            window.sessionStorage.removeItem("iswatch")
          } else {
            // 驳回预算后
            window.sessionStorage.setItem("iseditys", "true")
            window.sessionStorage.removeItem("iswatch")
          }
        }
      }
      const { href } = this.$router.resolve({ path: "/declare/declare" })
      window.open(href, "_blank")
    }
    // 查看
    else {
      debugger
      if (val.state == 4) {
        window.sessionStorage.setItem("iseditys", "true")
        window.sessionStorage.setItem("iswatch", "true")
      } else {
        window.sessionStorage.setItem("iswatch", "true")
        // val.isrefuse == 1 查看驳回预算后重新提交的数据
        // val.isrefuse == 0 查看正常提交的数据
        if (val.isrefuse == 1) {
          window.sessionStorage.setItem("iseditys", "true")
          window.sessionStorage.setItem("fziseditys", "false")
          if (val.state == 1) {
            window.sessionStorage.setItem("topicinfo", topicinfo)
          }
        } else {
          window.sessionStorage.removeItem("iseditys")
          if (val.state == 1) {
            window.sessionStorage.setItem("topicinfo", topicinfo)
          }
        }
      }

      window.sessionStorage.setItem("topicid", JSON.stringify(addparm))

      const { href } = this.$router.resolve({ path: "/declare/declare" })
      window.open(href, "_blank")
    }
  }
  /**
   * 撤回课题
   */
  backitem(val) {
    let tootop = "";
    if (val.name == null) {
      val.name = null;
      tootop = "确定撤回课题吗？";
    } else {
      tootop = '确定撤回课题"' + val.name + '"吗'
    }
    this.$confirm(tootop, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let param: any = {
          guideid: val.guideid,
          id: val.id,
          isdelete: 0,
          level: val.level,
          num: val.num,
          topicName: val.topicName,
          topictype: val.topictype,
          updatetime: val.createtime,
          userId: val.userId,
        };
        // 提交预算驳回数据后撤销
        if (val.isrefuse == "1") {
          param.state = 4;
        } else {
          param.state = 3;
        }
        updatetopic(param).then((res) => {
          if (res.code == 200) {
            this.getlist();
          }
        });
      })
      .catch(() => {
        throw new Error("取消成功！");
      });
  }
  /**
   * 删除课题
   */
  deleteitem(val) {
    let tootop = "";
    if (val.name == null) {
      val.name = null;
      tootop = "确定删除课题吗？";
    } else {
      tootop = '确定删除课题"' + val.name + '"吗';
    }
    this.$confirm(tootop, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let param = {
          dismiss: val.dismiss,
          fund: val.fund,
          guideid: val.guideid,
          id: val.id,
          isdelete: 1,
          level: val.level,
          num: val.num,
          state: val.state,
          topicName: val.topicName,
          topictype: val.topictype,
          updatetime: val.updatetime,
          userId: val.userId,
        };
        updatetopic(param).then((res) => {
          if (res.code == 200) {
            this.getlist();
          }
        });
      })
      .catch(() => {});
  }
  showrefuse(param) {
    this.$alert(param.dismiss, "课题驳回原因", {
      confirmButtonText: "确定",
    });
  }
  // editdate(val, event) {
  //   let addparm = {
  //     topicId: val.id,
  //   };
  //   let topicinfo: any = JSON.stringify(val);
  //   window.sessionStorage.setItem("topicid", JSON.stringify(addparm));
  //   window.sessionStorage.setItem("topicinfo", topicinfo);
  //   window.sessionStorage.removeItem("fziseditys");
  //   if (val.state == 4) {
  //     window.sessionStorage.setItem("iseditys", "true");
  //     window.sessionStorage.setItem("iswatch", "true");
  //   } else {
  //     if (val.isrefuse == 1) {
  //       window.sessionStorage.setItem("fziseditys", "false");
  //     } else {
  //       if (val.state == 5) {
  //         //  驳回后
  //         window.sessionStorage.removeItem("iseditys");
  //         window.sessionStorage.removeItem("iswatch");
  //       } else if (val.state == 3) {
  //         window.sessionStorage.removeItem("iseditys");
  //         window.sessionStorage.removeItem("iswatch");
  //       } else {
  //         // 驳回预算后
  //         window.sessionStorage.setItem("iseditys", "true");
  //         window.sessionStorage.removeItem("iswatch");
  //       }
  //     }
  //   }
  //   const { href } = this.$router.resolve({ path: "/declare/declare" });
  //   window.open(href, "_blank");
  // }
  handleWatch(row) {
    let href = this.baseurl + row.loadPath;
    const savea = document.createElement("a");
    savea.download = "xxxx";
    savea.href = href;
    savea.click();
  }
}
